import { render } from "./Contact.vue?vue&type=template&id=2f4c25a3&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=2f4c25a3&scoped=true&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4c25a3"]])

export default __exports__